import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { getNonSampleCustomerIds } from 'store/entities/customers/selectors';
import { getChatsLoaded } from 'store/views/chats/selectors';

interface IUseCustomersCount {
  customersCount: number;
  isLoading: boolean;
}

export const useCustomersCount = (): IUseCustomersCount => {
  const isChatsLoaded = useSelector(getChatsLoaded);
  const customersCount = useSelector(getNonSampleCustomerIds).length;

  return useMemo(() => {
    if (!isChatsLoaded) {
      return { customersCount: 0, isLoading: true };
    }

    return { customersCount, isLoading: false };
  }, [isChatsLoaded, customersCount]);
};
